import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

const saveWidgetPrefs = (prefs) => localStorage.setItem('dashboard_widgets', JSON.stringify(prefs));

export const WidgetSettingsDialog = ({ open, onOpenChange, widgets, setWidgets, toggleWidget, options, tr }) => {
  const handleShowAll = () => {
    const all = {};
    options.forEach(w => { all[w.key] = true; });
    setWidgets(all);
    saveWidgetPrefs(all);
    api.post('/dashboard/layout', { widgets: all }).catch(() => {});
    toast.success('All widgets enabled');
  };
  const handleMinimize = () => {
    const none = {};
    options.forEach(w => { none[w.key] = false; });
    none.stats = true;
    setWidgets(none);
    saveWidgetPrefs(none);
    api.post('/dashboard/layout', { widgets: none }).catch(() => {});
    toast.success('Minimized dashboard');
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="widget-settings-dialog">
        <DialogHeader><DialogTitle className="font-outfit">{tr('customize_widgets')}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground mb-2">{tr('customize_widgets')}</p>
        <div className="space-y-2 max-h-[50dvh] overflow-y-auto pr-1">
          {options.map(w => (
            <div
              key={w.key}
              className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-all ${widgets[w.key] ? 'bg-success/5 border-success/30' : 'bg-muted/50 border-border hover:border-border'}`}
              onClick={() => toggleWidget(w.key)}
            >
              <button
                className={`w-10 h-6 rounded-full relative transition-colors flex-shrink-0 ${widgets[w.key] ? 'bg-success' : 'bg-stone-300'}`}
                data-testid={`widget-toggle-${w.key}`}
              >
                <span className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${widgets[w.key] ? 'left-5' : 'left-1'}`} />
              </button>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium">{tr(w.labelKey)}</p>
                <p className="text-xs text-muted-foreground truncate">{tr(w.descKey)}</p>
              </div>
              {widgets[w.key] ? <Eye size={16} className="text-success flex-shrink-0" /> : <EyeOff size={16} className="text-muted-foreground flex-shrink-0" />}
            </div>
          ))}
        </div>
        <div className="flex gap-2 mt-3 pt-3 border-t">
          <Button variant="outline" size="sm" className="flex-1 rounded-xl" onClick={handleShowAll} data-testid="widget-show-all">{tr('show_all')}</Button>
          <Button variant="outline" size="sm" className="flex-1 rounded-xl" onClick={handleMinimize} data-testid="widget-minimize">{tr('minimize')}</Button>
          <Button size="sm" className="flex-1 rounded-xl" onClick={() => onOpenChange(false)} data-testid="widget-done">{tr('done')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
